module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/iPhone-13-8532898ac3071de6acf0895571750329.png";